import { BaseItem } from './common';
import { HasEntityIdPartial } from './entityId';
import * as Billing from './workflow/billing';
import * as ExportAllergies from './workflow/exportAllergies';
import * as ExportAppointmentNote from './workflow/exportAppointmentNote';
import * as ExportAppointmentStatus from './workflow/exportAppointmentStatus';
import * as ExportAuthorizationForm from './workflow/exportAuthorizationForm';
import * as ExportAuthorizationStatus from './workflow/exportAuthorizationStatus';
import * as ExportAuthorizationSubmission from './workflow/exportAuthorizationSubmission';
import * as ExportCareGapFindings from './workflow/exportCareGapFindings';
import * as ExportChargeReview from './workflow/exportChargeReview';
import * as ExportClinicalComment from './workflow/exportClinicalComment';
import * as ExportEncounterInformation from './workflow/exportEncounterInformation';
import * as ExportFamilyMedicalHistory from './workflow/exportFamilyMedicalHistory';
import * as ExportFollowUp from './workflow/exportFollowUp';
import * as ExportForms from './workflow/exportForms';
import * as ExportGeneralComment from './workflow/exportGeneralComment';
import * as ExportGuarantor from './workflow/exportGuarantor';
import * as ExportHccFindings from './workflow/exportHccFindings';
import * as ExportMarkAsReviewed from './workflow/exportMarkAsReviewed';
import * as ExportMedications from './workflow/exportMedications';
import * as ExportNoteCheckedIn from './workflow/exportNoteCheckedIn';
import * as ExportNoticeOfAdmission from './workflow/exportNoticeOfAdmission';
import * as ExportPatientCareProviders from './workflow/exportPatientCareProviders';
import * as ExportPatientInformation from './workflow/exportPatientInformation';
import * as ExportPatientInsuranceInformation from './workflow/exportPatientInsuranceInformation';
import * as ExportPatientMedicalHistory from './workflow/exportPatientMedicalHistory';
import * as ExportPatientPharmacies from './workflow/exportPatientPharmacies';
import * as ExportPatientUploads from './workflow/exportPatientUploads';
import * as ExportPatientUploadStatuses from './workflow/exportPatientUploadStatuses';
import * as ExportPayorAuthorization from './workflow/exportPayorAuthorization';
import * as ExportPreregistrationEncounter from './workflow/exportPreregistrationEncounter';
import * as ExportProcessedPayments from './workflow/exportProcessedPayments';
import * as ExportRegistrationNote from './workflow/exportRegistrationNote';
import * as ExportScheduledAppointment from './workflow/exportScheduledAppointment';
import * as ExportScheduledOrderAssociation from './workflow/exportScheduledOrderAssociation';
import * as ExportSocialHistory from './workflow/exportSocialHistory';
import * as ExportSurgicalHistory from './workflow/exportSurgicalHistory';
import * as ExportTerminatedInsurances from './workflow/exportTerminatedInsurances';
import * as ExportVerifyRegistration from './workflow/exportVerifyRegistration';
import * as ExtractAuthorizationStatus from './workflow/extractAuthorizationStatus';
import * as ExtractNoticeOfAdmissionStatus from './workflow/extractNoticeOfAdmissionStatus';
import * as ExtractPatientAdvisories from './workflow/extractPatientAdvisories';
import * as ExtractPatientAdvisoryDocuments from './workflow/extractPatientAdvisoryDocuments';
import * as ExtractPatientDocuments from './workflow/extractPatientDocuments';
import * as ExtractPatientInsuranceRteInformation from './workflow/extractPatientInsuranceRteInformation';
import * as ExtractPatientOrder from './workflow/extractPatientOrder';
import * as ExtractPayorAuthorizationStatus from './workflow/extractPayorAuthorizationStatus';
import * as Note from './workflow/note';
import * as Order from './workflow/order';
import * as Previsit from './workflow/previsit';
import * as ProblemGroup from './workflow/problemGroup';
import * as QualityMeasure from './workflow/qualityMeasure';
import * as TrainingSegments from './workflow/trainingSegments';

export {
  Billing,
  ExportAllergies,
  ExportAppointmentNote,
  ExportAppointmentStatus,
  ExportAuthorizationForm,
  ExportAuthorizationStatus,
  ExportAuthorizationSubmission,
  ExportCareGapFindings,
  ExportChargeReview,
  ExportClinicalComment,
  ExportEncounterInformation,
  ExportFamilyMedicalHistory,
  ExportFollowUp,
  ExportForms,
  ExportHccFindings,
  ExportGeneralComment,
  ExportGuarantor,
  ExportMarkAsReviewed as ExportMarkAllAsReviewed,
  ExportMedications,
  ExportNoteCheckedIn,
  ExportNoticeOfAdmission,
  ExportPatientCareProviders,
  ExportPatientInformation,
  ExportPatientInsuranceInformation,
  ExportPatientMedicalHistory,
  ExportPatientPharmacies,
  ExportPatientUploads,
  ExportPatientUploadStatuses,
  ExportPayorAuthorization,
  ExportPreregistrationEncounter,
  ExportProcessedPayments,
  ExportRegistrationNote,
  ExportScheduledAppointment,
  ExportScheduledOrderAssociation,
  ExportSocialHistory,
  ExportSurgicalHistory,
  ExportTerminatedInsurances,
  ExportVerifyRegistration,
  ExtractAuthorizationStatus,
  ExtractNoticeOfAdmissionStatus,
  ExtractPatientAdvisories,
  ExtractPatientAdvisoryDocuments,
  ExtractPatientDocuments,
  ExtractPatientInsuranceRteInformation,
  ExtractPatientOrder,
  ExtractPayorAuthorizationStatus, // DEPRECATED
  Note,
  Order,
  Previsit,
  ProblemGroup,
  QualityMeasure,
  TrainingSegments,
};

export const Kinds = [
  Billing.Kind,
  ExportAllergies.Kind,
  ExportAppointmentNote.Kind,
  ExportAppointmentStatus.Kind,
  ExportAuthorizationForm.Kind,
  ExportAuthorizationStatus.Kind,
  ExportAuthorizationSubmission.Kind,
  ExportCareGapFindings.Kind,
  ExportChargeReview.Kind,
  ExportClinicalComment.Kind,
  ExportEncounterInformation.Kind,
  ExportFamilyMedicalHistory.Kind,
  ExportFollowUp.Kind,
  ExportForms.Kind,
  ExportGeneralComment.Kind,
  ExportGuarantor.Kind,
  ExportHccFindings.Kind,
  ExportMarkAsReviewed.Kind,
  ExportMedications.Kind,
  ExportNoteCheckedIn.Kind,
  ExportNoticeOfAdmission.Kind,
  ExportPatientCareProviders.Kind,
  ExportPatientInformation.Kind,
  ExportPatientInsuranceInformation.Kind,
  ExportPatientMedicalHistory.Kind,
  ExportPatientPharmacies.Kind,
  ExportPatientUploads.Kind,
  ExportPatientUploadStatuses.Kind,
  ExportPayorAuthorization.Kind,
  ExportPreregistrationEncounter.Kind,
  ExportProcessedPayments.Kind,
  ExportRegistrationNote.Kind,
  ExportScheduledAppointment.Kind,
  ExportScheduledOrderAssociation.Kind,
  ExportSocialHistory.Kind,
  ExportSurgicalHistory.Kind,
  ExportTerminatedInsurances.Kind,
  ExportVerifyRegistration.Kind,
  ExtractAuthorizationStatus.Kind,
  ExtractNoticeOfAdmissionStatus.Kind,
  ExtractPatientAdvisories.Kind,
  ExtractPatientAdvisoryDocuments.Kind,
  ExtractPatientDocuments.Kind,
  ExtractPatientInsuranceRteInformation.Kind,
  ExtractPatientOrder.Kind,
  Note.Kind,
  Order.Kind,
  Previsit.Kind,
  ProblemGroup.Kind,
  QualityMeasure.Kind,
  TrainingSegments.Kind,
] as const;

export type Kind = (typeof Kinds)[number];

export type Status<TKind extends Kind = Kind> = {
  [Billing.Kind]: Billing.Status;
  [ExportAllergies.Kind]: ExportAllergies.Status;
  [ExportAppointmentNote.Kind]: ExportAppointmentNote.Status;
  [ExportAppointmentStatus.Kind]: ExportAppointmentStatus.Status;
  [ExportAuthorizationForm.Kind]: ExportAuthorizationForm.Status;
  [ExportAuthorizationStatus.Kind]: ExportAuthorizationStatus.Status;
  [ExportAuthorizationSubmission.Kind]: ExportAuthorizationSubmission.Status;
  [ExportCareGapFindings.Kind]: ExportCareGapFindings.Status;
  [ExportChargeReview.Kind]: ExportChargeReview.Status;
  [ExportClinicalComment.Kind]: ExportClinicalComment.Status;
  [ExportEncounterInformation.Kind]: ExportEncounterInformation.Status;
  [ExportFamilyMedicalHistory.Kind]: ExportFamilyMedicalHistory.Status;
  [ExportFollowUp.Kind]: ExportFollowUp.Status;
  [ExportForms.Kind]: ExportForms.Status;
  [ExportGeneralComment.Kind]: ExportGeneralComment.Status;
  [ExportGuarantor.Kind]: ExportGuarantor.Status;
  [ExportHccFindings.Kind]: ExportHccFindings.Status;
  [ExportMarkAsReviewed.Kind]: ExportMarkAsReviewed.Status;
  [ExportMedications.Kind]: ExportMedications.Status;
  [ExportNoteCheckedIn.Kind]: ExportNoteCheckedIn.Status;
  [ExportNoticeOfAdmission.Kind]: ExportNoticeOfAdmission.Status;
  [ExportPatientCareProviders.Kind]: ExportPatientCareProviders.Status;
  [ExportPatientInformation.Kind]: ExportPatientInformation.Status;
  [ExportPatientInsuranceInformation.Kind]: ExportPatientInformation.Status;
  [ExportPatientMedicalHistory.Kind]: ExportPatientMedicalHistory.Status;
  [ExportPatientPharmacies.Kind]: ExportPatientPharmacies.Status;
  [ExportPatientUploads.Kind]: ExportPatientUploads.Status;
  [ExportPatientUploadStatuses.Kind]: ExportPatientUploadStatuses.Status;
  [ExportPayorAuthorization.Kind]: ExportPayorAuthorization.Status;
  [ExportPreregistrationEncounter.Kind]: ExportPreregistrationEncounter.Status;
  [ExportProcessedPayments.Kind]: ExportProcessedPayments.Status;
  [ExportRegistrationNote.Kind]: ExportRegistrationNote.Status;
  [ExportScheduledAppointment.Kind]: ExportScheduledAppointment.Status;
  [ExportScheduledOrderAssociation.Kind]: ExportScheduledOrderAssociation.Status;
  [ExportSocialHistory.Kind]: ExportSocialHistory.Status;
  [ExportSurgicalHistory.Kind]: ExportSurgicalHistory.Status;
  [ExportTerminatedInsurances.Kind]: ExportTerminatedInsurances.Status;
  [ExportVerifyRegistration.Kind]: ExportVerifyRegistration.Status;
  [ExtractAuthorizationStatus.Kind]: ExtractAuthorizationStatus.Status;
  [ExtractNoticeOfAdmissionStatus.Kind]: ExtractNoticeOfAdmissionStatus.Status;
  [ExtractPatientAdvisories.Kind]: ExtractPatientAdvisories.Status;
  [ExtractPatientAdvisoryDocuments.Kind]: ExtractPatientAdvisoryDocuments.Status;
  [ExtractPatientDocuments.Kind]: ExtractPatientDocuments.Status;
  [ExtractPatientInsuranceRteInformation.Kind]: ExtractPatientInsuranceRteInformation.Status;
  [ExtractPatientOrder.Kind]: ExtractPatientOrder.Status;
  [Note.Kind]: Note.Status;
  [Order.Kind]: Order.Status;
  [Previsit.Kind]: Previsit.Status;
  [ProblemGroup.Kind]: ProblemGroup.Status;
  [QualityMeasure.Kind]: QualityMeasure.Status;
  [TrainingSegments.Kind]: TrainingSegments.Status;
}[TKind];

export const StatusValues: Status[] = [
  Billing.Status,
  Note.Status,
  ExportNoteCheckedIn.Status,
  Order.Status,
  Previsit.Status,
  ProblemGroup.Status,
  QualityMeasure.Status,
  TrainingSegments.Status,
].reduce<Status[]>(
  (accum, statusEnum) => [...accum, ...Object.values(statusEnum)],
  [],
);

export interface KindAndStatusGroup {
  kind: Kind;
  status?: Status;
}

export interface FindAllOptions {
  startTime?: Date; // earliest workflow.created
  endTime?: Date; // latest workflow.created
  kindAndStatusGroups?: KindAndStatusGroup[];
  providerUserId?: string;
  practiceGroupId?: string;
  practiceId?: string;
  specialty?: string;
  assignedAnalystUserId?: string;
  encounterId?: string;
  encounterStartTimeBefore?: Date;
  encounterStartTimeAfter?: Date;
  limit?: number;
  ehrInformationId?: string;
  formSetCreatedTimeBefore?: Date;
  formSetCreatedTimeAfter?: Date;
}

interface BaseWorkflow<TKind extends Kind = Kind> {
  encounterId: string;
  kind: TKind;
  status: Status<TKind>;
  isCurrent: boolean;
  reasonsForReview: string[] | null;
  userId: string | null;
}
type BaseWorkflowV2<TKind extends Kind = Kind> = HasEntityIdPartial & {
  kind: TKind;
  status: Status<TKind>;
  reasonsForReview: string[] | null;
  userId: string | null;
  isCurrent: boolean;
};

export interface CreateValues<TKind extends Kind = Kind>
  extends Omit<
    BaseWorkflowV2<TKind>,
    'isCurrent' | 'reasonsForReview' | 'userId'
  > {}

export interface Workflow<TKind extends Kind = Kind>
  extends BaseWorkflow<TKind>,
    BaseItem {}
export type WorkflowV2<TKind extends Kind = Kind> = BaseWorkflowV2<TKind> &
  BaseItem;

export type NoteWorkflow = Workflow<typeof Note.Kind>;
export type EncounterWorkflow = Workflow;

export interface DisplayableWorkflowOfKind<TKind extends Kind = Kind>
  extends Workflow<TKind> {
  ehrReferenceValue?: string;
  specialty?: string;
  kindOfVisit?: string;
  assignedAnalystUserId?: string;
  completedTimestamp: Date | null;
  patientId: string;
  patientFirstName: string;
  patientLastName: string;
  providerUserId: string;
  practiceId: string;
}

type DisplayableWorkflowOfKindV2<TKind extends Kind = Kind> =
  WorkflowV2<TKind> & {
    ehrReferenceValue?: string;
    specialty?: string;
    kindOfVisit?: string;
    assignedAnalystUserId?: string;
    completedTimestamp?: Date | null;
    patientId: string;
    patientFirstName: string;
    patientLastName: string;
    providerUserId?: string;
    practiceId: string;
  };

export type DisplayableBillingWorkflow = DisplayableWorkflowOfKind<
  typeof Billing.Kind
>;
export type DisplayableExportNoteCheckedInWorkflow = DisplayableWorkflowOfKind<
  typeof ExportNoteCheckedIn.Kind
>;
export type DisplayableExportPatientUploadsWorkflow = DisplayableWorkflowOfKind<
  typeof ExportPatientUploads.Kind
>;
export type DisplayableNoteWorkflow = DisplayableWorkflowOfKind<
  typeof Note.Kind
>;
export type DisplayableOrderWorkflow = DisplayableWorkflowOfKind<
  typeof Order.Kind
>;
export type DisplayablePrevisitWorkflow = DisplayableWorkflowOfKindV2<
  typeof Previsit.Kind
>;
export type DisplayableProblemGroupWorkflow = DisplayableWorkflowOfKind<
  typeof ProblemGroup.Kind
>;
export type DisplayableTrainingSegmentsWorkflow = DisplayableWorkflowOfKind<
  typeof TrainingSegments.Kind
>;

export type DisplayableWorkflow =
  | DisplayableBillingWorkflow
  | DisplayableExportNoteCheckedInWorkflow
  | DisplayableExportPatientUploadsWorkflow
  | DisplayableNoteWorkflow
  | DisplayableOrderWorkflow
  | DisplayablePrevisitWorkflow
  | DisplayableProblemGroupWorkflow
  | DisplayableTrainingSegmentsWorkflow;

export enum ViewEntity {
  Encounter = 'ENCOUNTER',
  EhrInformation = 'EHR_INFORMATION',
  PatientOrder = 'PATIENT_ORDER',
}

export type ViewOptions = Partial<{
  entity: ViewEntity;
  kinds: Kind[];
  status: string;
  failureReason: string;
  failureReasons: string[];
  after: Date;
  before: Date;
  practiceIds: string[];
  practiceGroupIds: string[];
  organizationIds: string[];
  page: number;
  limit: number;
  // entity specific
  payers: string[];
  encounterId: string;
  ehrInformationId: string;
  patientOrderId: string;
}>;

export type ViewWorkflow = WorkflowV2 & {
  ehrReferenceValue: string;
  startTime: Date;
  patientEhrId: string;
  organization: string;
  practiceGroup: string;
  practice: string;
  analystName: string;
};

export const VIEW_WORKFLOW_KINDS = [
  // exports
  ExportAllergies.Kind,
  ExportAppointmentNote.Kind,
  ExportAuthorizationForm.Kind,
  ExportAuthorizationStatus.Kind,
  ExportAuthorizationSubmission.Kind,
  ExportCareGapFindings.Kind,
  ExportChargeReview.Kind,
  ExportClinicalComment.Kind,
  ExportFamilyMedicalHistory.Kind,
  ExportFollowUp.Kind,
  ExportForms.Kind,
  ExportGeneralComment.Kind,
  ExportMarkAsReviewed.Kind,
  ExportMedications.Kind,
  ExportNoteCheckedIn.Kind,
  ExportPatientCareProviders.Kind,
  ExportPatientInformation.Kind,
  ExportPatientInsuranceInformation.Kind,
  ExportPatientMedicalHistory.Kind,
  ExportPatientPharmacies.Kind,
  ExportPatientUploads.Kind,
  ExportPatientUploadStatuses.Kind,
  ExportPayorAuthorization.Kind,
  ExportPreregistrationEncounter.Kind,
  ExportProcessedPayments.Kind,
  ExportRegistrationNote.Kind,
  ExportScheduledAppointment.Kind,
  ExportScheduledOrderAssociation.Kind,
  ExportSocialHistory.Kind,
  ExportSurgicalHistory.Kind,
  ExportTerminatedInsurances.Kind,
  // special cased export workflow kinds that do not conform to usual naming conventions
  Billing.Kind,
  Note.Kind,
  Order.Kind,
  ProblemGroup.Kind,
  // extracts
  ExtractAuthorizationStatus.Kind,
  ExtractPatientAdvisories.Kind,
  ExtractPatientAdvisoryDocuments.Kind,
  ExtractPatientInsuranceRteInformation.Kind,
  ExtractPatientOrder.Kind,
  ExtractPayorAuthorizationStatus.Kind, // DEPRECATED
];

export const WORKFLOW_KINDS_TO_RETRY: Kind[] = [
  ExportAllergies.Kind,
  ExportAppointmentNote.Kind,
  ExportAuthorizationForm.Kind,
  ExportAuthorizationStatus.Kind,
  ExportAuthorizationSubmission.Kind,
  ExportEncounterInformation.Kind,
  ExportFamilyMedicalHistory.Kind,
  ExportGeneralComment.Kind,
  ExportGuarantor.Kind,
  ExportMedications.Kind,
  ExportPatientCareProviders.Kind,
  ExportPatientInformation.Kind,
  ExportPatientPharmacies.Kind,
  ExportPayorAuthorization.Kind,
  ExportPreregistrationEncounter.Kind,
  ExportVerifyRegistration.Kind,
  ExtractAuthorizationStatus.Kind,
  ExtractPatientAdvisoryDocuments.Kind,
  ExtractPatientOrder.Kind,
];
